import Swiper from 'swiper/bundle';
import gsap from 'gsap';
import * as imagesLoaded from 'imagesloaded';
import { TweenMax, Power2 } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {pJS} from 'particles.js';
gsap.registerPlugin(ScrollTrigger);


export function index(){
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh',`${vh}px`)

	const particles = document.getElementById('particles');
	const particlePath = './dist/json/particlesjs-config.json'
	if(particles){
		particlesJS.load('particles', particlePath);
	}

  const scrolEvents = document.querySelectorAll(".scroll-event")
  scrolEvents.forEach((el) => {
    ScrollTrigger.create({
      trigger: el,
      //markers: true,
      start: "top bottom",
      end: "bottom top",
      once: true,
      toggleClass: {targets: el, className: "active"},
    });
  })


};